module.exports = __webpack_public_path__ + "img/news-bg.84ebf2e.png";